//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DesignSimulation.js";
import "../no/Builder.js";
let d=[[[0,"DatasetName",1,0],[0,"ImageBackground",1,0],[0,"ImageSize",1,0],[0,"NumTextLabels",0,0],[0,"OpenDocument",1,0],[0,"OutputFileName",1,0],[0,"SaveBehavior",1,0],[0,"SaveImages",1,0],[0,"TemplateFileName",1,0],[0,"ViewportSettingsBuilderCount",0,0]],[[["textLabelIndex"],"GetNthTextLabelUserName",{R_:{userName:''}},1,0],[["textLabelIndex"],"IsNthTextLabelReadOnly",{R_:{isReadOnly:''}},1,0],[["textLabelIndex"],"GetNthTextLabelID",{R_:{label:''}},1,0],[["label"],"GetTextValueOfLabel",{R_:{value:''}},1,0],[["label","value"],"SetTextValueOfLabel",{},2,0],[[],"CreateViewportSettingsBuilder",{R_:{newBuilder:"DesignSimulation.ViewportSettingsBuilder"}},0,0],[["index"],"GetViewportSettingsBuilder",{R_:{viewportSettingsBuilder:"DesignSimulation.ViewportSettingsBuilder"}},1,0],[["index"],"RemoveViewportSettingsBuilder",{},1,0]],[]];
SPLM.DesignSimulation.AnalysisReportBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DesignSimulation.AnalysisReportBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DesignSimulation.AnalysisReportBuilder.SaveBehaviorOption = Object.freeze({
    "Create" : "Create", "Overwrite" : "Overwrite", "Native" : "Native"});

SPLM.DesignSimulation.AnalysisReportBuilder.ImageBackgroundOption = Object.freeze({
    "Original" : "Original", "Transparent" : "Transparent"});

SPLM.DesignSimulation.AnalysisReportBuilder.ImageSizeOption = Object.freeze({
    "Small" : "Small", "Medium" : "Medium", "Large" : "Large"});

export default SPLM;